/**
 * The server's low-battery levels, as the console says them (Akash,
 * 2026-10-31, spa 0.5.69).
 *
 * The alerts engine raises `robot_battery_low` at fixed levels -- code
 * constants, not settings (`alerts_engine._ROBOT_BATTERY_*`) -- and the
 * Profile tells every person at the hotel what they are. These are those
 * numbers, held equal to `tests/fixtures/contracts/alert-rules.json`'s
 * `robot_battery_low` block by `tests/unit/battery-levels-contract.test.ts`;
 * the backend holds the same block equal to the engine. Change one and a
 * test fails until the other side says the same.
 */

/** LOW: a warning once a robot with no job has not moved or charged for
 * `BATTERY_LOW_AFTER_MIN`; a robot on a job is left to finish it. */
export const BATTERY_LOW_PCT = 20;
/** VERY LOW: urgent (critical), and always pops up. */
export const BATTERY_VERY_LOW_PCT = 10;
/** How long a low robot must stay put, uncharged, before the alert opens. */
export const BATTERY_LOW_AFTER_MIN = 10;
